var _rect, _clipPath, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 30,
    viewBox: "0 0 44 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 29,
    rx: 2,
    fill: "white",
    stroke: "#E4E7EC"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "discoverClip"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 30,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#discoverClip)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 30C33 30.5 44 24.5 44 15.5V30H17Z",
    fill: "#F48120"
  }), /*#__PURE__*/React.createElement("text", {
    x: 4,
    y: 15.5,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 6.4,
    fontWeight: 800,
    letterSpacing: 0.2,
    fill: "#231F20"
  }, "DISC"), /*#__PURE__*/React.createElement("circle", {
    cx: 24.1,
    cy: 13.4,
    r: 2.6,
    fill: "#F48120"
  }), /*#__PURE__*/React.createElement("text", {
    x: 27.4,
    y: 15.5,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 6.4,
    fontWeight: 800,
    letterSpacing: 0.2,
    fill: "#231F20"
  }, "VER"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.41f41b0a7b2e11abff1c6d1de239c3a4.svg";
export { ForwardRef as ReactComponent };